var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongodbIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "549px",
    viewBox: "0 0 256 549",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MongoDB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175.621976,61.1079707 C152.611447,33.8066743 132.796647,6.0788184 128.748652,0.319937648 C128.322413,-0.106645883 127.683054,-0.106645883 127.257028,0.319937648 C123.20882,6.0788184 103.394233,33.8066743 80.383491,61.1079707 C-117.123869,313.004377 111.490649,482.998814 111.490649,482.998814 L113.408086,484.278812 C115.112404,510.512377 119.373732,548.265926 119.373732,548.265926 L127.896173,548.265926 L136.418615,548.265926 C136.418615,548.265926 140.679943,510.72571 142.384474,484.278812 L144.301911,482.785481 C144.514818,482.998814 373.130189,313.004377 175.621976,61.1079707 Z M127.896173,479.158819 C127.896173,479.158819 117.669414,470.414298 114.899498,465.936437 L114.899498,465.507638 L127.257028,191.215955 C127.257028,190.362623 128.535533,190.362623 128.535533,191.215955 L140.892849,465.507638 L140.892849,465.936437 C138.123146,470.414298 127.896173,479.158819 127.896173,479.158819 Z",
    fill: "#01EC64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodbIcon1);
export default __webpack_public_path__ + "static/media/mongodb-icon-1.8869f2f6c8ef3b4798e6fa8649bfaac0.svg";
export { ForwardRef as ReactComponent };